// ResetPasswordPage.jsx
// Place this file in your React app (e.g. src/pages/ResetPasswordPage.jsx)
// Usage: add a route for path="/resetpassword" that renders this component.
// Example: <Route path="/resetpassword" element={<ResetPasswordPage/>} />

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { API_BASE_URL, ENDPOINTS } from '../../config';
import { Notyf } from "notyf";
const notyf = new Notyf({
    position: { x: "right", y: "top" },
    ripple: true,
    dismissible: true,
});
// Edit this if your API base is different
const API_BASE = API_BASE_URL || "https://ai.holaai.in";

export default function ResetPasswordPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const [token, setToken] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const t = params.get("token") || "";
        if (t) setToken(t);
    }, [location.search]);

    function validate() {

        if (!token) return notyf.error("Reset token is required. Paste it or open the link from your email.");
        if (!newPassword || newPassword.length < 8) return notyf.error("Password must be at least 8 characters.");
        if (newPassword !== confirmPassword) return notyf.error("Passwords do not match.");
        return true;
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (!validate()) return;
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/auth/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: token.trim(), new_password: newPassword }),
            });

            const data = await res.json();
            if (!res.ok) {
                const detail = data.detail || data.message || "Failed to reset password";
                notyf.error(detail);
                setLoading(false);
                return;
            }

            notyf.success(data.message || "Password has been reset successfully.");

            setLoading(false);
            // auto-redirect to login after 3 seconds
            setTimeout(() => navigate("/", { replace: true }), 3000);
        } catch (err) {
            notyf.error("Network error. Please try again later.");
            setLoading(false);
        }
    }

    return (
        <div className="auth-body login">
            <motion.div
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25 }}
                className="w-full max-w-md shadow-lg rounded-2xl p-6"
            >
                <div className="auth-background">
                    <div className="bg-pattern"></div>
                    <div className="floating-elements">
                        <div className="floating-element"><i className="fas fa-brain"></i></div>
                        <div className="floating-element"><i className="fas fa-robot"></i></div>
                        <div className="floating-element"><i className="fas fa-chart-line"></i></div>
                        <div className="floating-element"><i className="fas fa-image"></i></div>
                    </div>
                </div>
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="auth-header">
                            <div className="brand-logo">
                                <h1><img src="assets/img/hola.png" alt="" className="logo" /></h1>
                            </div>
                            <p><strong>Reset Password</strong></p>
                            <p>Enter a new password for your HolaAI account.</p>
                            {/* {message ? (
                                <div className="bg-green-50 border-green-200 text-green-800 p-3 rounded mb-4">
                                    <strong>{message}</strong>
                                    <div className="text-xs mt-1">Redirecting to login...</div>
                                </div>
                            ) : null} */}

                            {/* {error ? (
                                <div className="bg-red-50 border-red-200 text-red-800 p-3 rounded mb-4">{error}</div>
                            ) : null} */}
                        </div>
                        <form className="auth-login-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Reset token</label>
                                <div className="input-group mb-2">
                                    <input
                                        className="form-control"
                                        value={token}
                                        onChange={(e) => setToken(e.target.value)}
                                        placeholder="Paste token here (or use the link from your email)"
                                    />
                                </div>
                                <p>If you clicked the reset link in email this should already be filled.</p>
                            </div>
                            <div className="form-group">
                                <label>New password</label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <i className="fas fa-lock"></i>
                                    </span>
                                    <input
                                        className="form-control"
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="At least 8 characters"
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Confirm password</label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <i className="fas fa-lock"></i>
                                    </span>
                                    <input
                                        className="form-control"
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Repeat new password"
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="btn btn-primary btn-auth"
                            >
                                {loading ? (
                                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                    </svg>
                                ) : null}
                                Reset password
                            </button>
                            <a href="/" className="btn btn-warning btn-auth">Back to login</a>
                        </form>
                        <p className="text-info">Tip: If the link in your email does not autofill the token, copy & paste the token value into the field above.</p>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
